import Swal from "sweetalert2";
import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Card, Empty } from "antd";
import { DetailAdminModel, AddAdmin } from "../../components/Model/index-model";
import Api from "../../api/Api";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import { t } from "i18next";
import { UserAddOutlined } from "@ant-design/icons";
import { Table, Input, Button } from "antd";
import Apiauth from "../../api/Apiauth";
import { withTranslation } from "react-i18next";
import AppContext from "../../components/AppContext";
import { hasPermission, openNotification, showToast } from "../../utils";
import { ColumnsUser } from "../../components/Columns/columns-user";

const { Search } = Input;
// const excludedRoles = ["Subowner", "Cs ( Auditor )"];
let isType = ["programer", "superadmin", "agent"];
let isRole = ["Subowner"];

class Index extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      activeTabKey1: "tab1",
      dropdownPlacement: "bottomRight",
      show: false,
      showModelAdd: false,
      showModelEdit: false,
      isData: null,
      isLoad: false,
      switchLoadindId: 0,
      dataTable: [],
      tableParams: {
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        filters: {},
        sortField: null,
        sortOrder: null,
      },
      dataRoles: [],
    };
    this.tableRef = React.createRef();
  }

  // --- Lifecycle Methods ---
  componentDidMount() {
    this.handleReload();
    if (this.context.setFetchAdminDataCallback) {
      this.context.setFetchAdminDataCallback(this.handleReload);
    }
    window.addEventListener("scroll", this.handleScroll);
  }
  handleReload = () => {
    this.setState({ isLoad: true }, () => {
      try {
        Promise.all([this.fetchData()]);
      } catch (error) {
        console.error("Error fetching data:", error);
        showToast("error", t("Failed to fetch data."));
      }
    });
  };
  componentDidUpdate(prevProps, prevState) {
    window.removeEventListener("scroll", this.handleScroll);
    const { tableParams } = this.state;
    const { tableParams: prevTableParams } = prevState;

    const paginationChanged =
      tableParams.pagination?.current !== prevTableParams.pagination?.current ||
      tableParams.pagination?.pageSize !== prevTableParams.pagination?.pageSize;

    const sortChanged =
      tableParams.sortOrder !== prevTableParams.sortOrder ||
      tableParams.sortField !== prevTableParams.sortField;

    const filtersChanged =
      JSON.stringify(tableParams.filters) !==
      JSON.stringify(prevTableParams.filters);

    if (paginationChanged || sortChanged || filtersChanged) {
      this.fetchData();
    }
  }
  // --- API Calls & Data Management ---
  setLoading = (_loading) => {
    this.setState({ isLoad: _loading });
  };
  handleScroll = () => {
    const tableElement = this.tableRef.current;
    if (tableElement) {
      const isAtBottom =
        tableElement.getBoundingClientRect().bottom <= window.innerHeight;
      this.setState({
        dropdownPlacement: isAtBottom ? "topLeft" : "bottomRight",
      });
    }
  };
  fetchData = () => {
    this.setLoading(true);
    const { tableParams } = this.state;
    const { setReloading } = this.context;

    Api.getallAdmin()
      .then((res) => {
        if (res?.data?.success) {
          const fetchedData = Array.isArray(res.data.data) ? res.data.data : [];
          let filteredResults = fetchedData;

          // ดึง filters ออกมาอย่างปลอดภัย กันพังถ้า filters เป็น null/undefined
          const filters = tableParams.filters || {};
          const { username } = filters;

          // ทำการ Filter ข้อมูล
          if (username) {
            filteredResults = fetchedData?.filter((item) =>
              item?.username?.toLowerCase().includes(username.toLowerCase()),
            );
          }

          let length = filteredResults?.filter((item) => !isType.includes(item.admin_type) || !isRole.includes(item.role)).length;

          this.setState((prevState) => {
            // ตรวจสอบว่าหน้าปัจจุบันเกินจำนวนข้อมูลที่มีหรือไม่ (กรณีลบหรือกรองจนข้อมูลลดลง)
            const currentPagination = prevState.tableParams.pagination;
            const pageSize = currentPagination.pageSize || 10;
            const maxPage = Math.ceil(length / pageSize) || 1;
            const newCurrent =
              currentPagination.current > maxPage
                ? maxPage
                : currentPagination.current;

            return {
              dataTable: filteredResults,
              isLoad: false,
              tableParams: {
                ...prevState.tableParams,
                pagination: {
                  ...currentPagination,
                  total: length,
                  current: newCurrent,
                },
              },
            };
          });
        } else {
          this.setState({ dataTable: [], isLoad: false });
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        if (typeof showToast === "function") {
          showToast("error", "ไม่สามารถโหลดข้อมูลผู้ดูแลระบบได้");
        }
        this.setState({ dataTable: [], isLoad: false });
      })
      .finally(() => {
        this.setLoading(false);
        setReloading(false);
      });
  };

  // ตรวจสอบสิทธิ์การลบ
  checkDeleteAllowed = (record) => {
    const { resProfileAdmin } = this.context;

    // ข้อมูลปัจจุบัน (คนที่จะลบ)
    const currentAdminRole = resProfileAdmin?.role;
    const currentAdminType = resProfileAdmin?.admin_type;

    // ข้อมูลเป้าหมาย (คนที่จะถูกลบ)
    const targetRole = record?.role; // หรือ record?.name ตามโครงสร้างข้อมูลคุณ
    const targetType = record?.admin_type;
    const adminMerchantId = record?.Active_merchantId;

    // กลุ่มที่ 1: Role ระดับสูงสุด (Super Users)
    const superPrivilegeTypes = ["programmer", "superadmin", "agent"];
    const superPrivilegeRoles = ["Owner", "Subowner"];

    // กลุ่มที่ 2: Role กลาง (พนักงานระดับบริหารในแต่ละ Merchant)
    // กลุ่มนี้สามารถลบคนในกลุ่มเดียวกันหรือระดับที่ต่ำกว่าได้ แต่ลบกลุ่มที่ 1 ไม่ได้
    const subRoles = [
      `Owner${adminMerchantId}`,
      `Subowner${adminMerchantId}`,
      `Head_Finance${adminMerchantId}`,
      `Head_Admin${adminMerchantId}`, // แก้ตัวสะกดจาก Adminr เป็น Admin
    ];

    // --- LOGIC การตรวจสอบ ---

    // 1. ถ้าคนลบอยู่ในกลุ่มอภิสิทธิ์ (Level 1) -> ลบได้ทุกคนเสมอ
    if (
      superPrivilegeTypes.includes(currentAdminType) ||
      superPrivilegeRoles.includes(currentAdminRole)
    ) {
      return true;
    }

    // 2. ถ้าคนลบอยู่ในกลุ่มพนักงานระดับบริหาร (Level 2 / SubRole)
    const isCurrentAdminSubRole = subRoles.includes(currentAdminRole);

    if (isCurrentAdminSubRole) {
      // เช็คว่า "เป้าหมาย" เป็นกลุ่มระดับสูง (Level 1) หรือไม่?
      const isTargetSuperUser =
        superPrivilegeTypes.includes(targetType) ||
        superPrivilegeRoles.includes(targetRole);

      if (isTargetSuperUser) {
        return false; // กลุ่มพนักงานห้ามลบระดับ Super User
      }

      // ถ้าเป้าหมายไม่ใช่ระดับสูง พนักงานระดับบริหาร (Level 2) สามารถลบได้
      return true;
    }

    // 3. ป้องกันกรณีสุดท้าย: ถ้าไม่ใช่ทั้งกลุ่ม 1 และกลุ่ม 2
    // ห้ามลบใครที่มีระดับสูงกว่าตนเอง
    if (
      superPrivilegeRoles.includes(targetRole) ||
      superPrivilegeTypes.includes(targetType) ||
      subRoles.includes(targetRole)
    ) {
      return false;
    }

    return true;
  };
  /**
   * ฟังก์ชัน Delete
   * @param {object|string} record - ข้อมูล
   * @param {string} type - ประเภทการทำรายการ
   * @param {boolean|string} status - สถานะ
   */
  handleDelete = async (record, type, status) => {
    if (!record) return alert("No data");
    const { resProfileAdmin } = this.context;
    const {
      id: targetId,
      username: targetUsername,
      admin_status: targetAdminStatus,
    } = record || {};

    const currentUser = {
      id: resProfileAdmin?.id,
      type: resProfileAdmin?.admin_type,
      role: resProfileAdmin?.role,
    };

    let isYou = targetId === currentUser.id;

    if (isYou)
      return alert(
        "Sorry, you cannot turn yourself on/off or delete yourself.",
      );

    let allowed = this.checkDeleteAllowed(record);

    if (!allowed) {
      return alert("Sorry, it's not possible to delete this item.");
    }

    this.setState({ switchLoadindId: targetId, isLoad: true });

    let txt = targetId === currentUser.id ? "Yourself" : targetUsername;

    let confirmButtonText =
      type === "delete"
        ? t("delete")
        : status === true
          ? t("enabled")
          : t("disabled");
    let txtStatusDel = `${t("You are about to", { txt: confirmButtonText, user: t(txt) })}`;
    let isStatus = status ? 1 : 0;
    let payload = {
      id: targetId,
      type: type,
      status: type === "status" ? isStatus : targetAdminStatus,
    };
    Swal.fire({
      title: t("Are you sure?"),
      text: txtStatusDel,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `${t("Confirm")}`,
      cancelButtonText: t("cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        Apiauth.deleteAdmin(payload)
          .then((res) => {
            if (res.status === 200) {
              setTimeout(() => {
                showToast(
                  "success",
                  res?.data?.message || "User deleted successfully!",
                );
                this.setState({ switchLoadindId: 0, isLoad: false }, () => {
                  this.fetchData();
                });
              }, 1500);
            } else {
              showToast(
                "error",
                res?.data?.message || "Failed to delete user.",
              );
              this.setState({ switchLoadindId: 0, isLoad: false });
            }
          })
          .catch((error) => {
            const errorMsg =
              error?.response?.data?.message ||
              error?.message ||
              "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้";
            if (error.status === 404) {
              openNotification(
                "error",
                `error: ${error?.status || ""}`,
                `${errorMsg || "N/A"}`,
              );
            } else {
              openNotification(
                "error",
                `error: ${error?.status || ""}`,
                `${errorMsg || "N/A"}`,
              );
            }
            console.error("Error deleting user:", error);

            this.setState({ switchLoadindId: 0, isLoad: false });
          });
      } else if (result.isDismissed) {
        showToast("info", "User deletion cancelled.");
        this.setState({ switchLoadindId: 0, isLoad: false });
      }
    });
  };
  // --- Modal Handlers ---
  handleShowDetail = (key) => {
    this.setState({ show: true, isData: key });
  };

  handleShowModelAdd = () => {
    this.setState({ showModelAdd: true });
  };
  handleCloseModals = () => {
    this.setState({
      show: false,
      showModelAdd: false,
      showModelEdit: false,
      isData: null,
      isLoad: false,
    });
  };
  onCreate = (values) => {
    console.log("Received values of form (onCreate):", values);
  };
  // --- Table Handlers ---
  handleTableChange = (pagination, filters, sorter) => {
    this.setState((prevState) => ({
      isLoad: true,
      tableParams: {
        ...prevState.tableParams,
        pagination,
        filters,
        sortField: sorter.field,
        sortOrder: sorter.order,
      },
    }));
  };
  onSearch = (value) => {
    this.setState(
      (prevState) => ({
        isLoad: true,
        tableParams: {
          ...prevState.tableParams,
          pagination: {
            ...prevState.tableParams.pagination,
            current: 1,
          },
          filters: {
            ...prevState.tableParams.filters,
            username: value,
          },
        },
      }),
      () => this.fetchData(),
    );
  };
  handleResetTwoFactor = (item) => {
    if (!item) {
      return alert(t("No data"));
    }
    let payload = {
      adminid: item?.id,
    };
    Swal.fire({
      title: t("Are you sure?"),
      text: t("Do you want to reset 2FA?", { admin: item?.username }),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("confirm"),
      cancelButtonText: t("cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        this.setLoading(true);

        try {
          Apiauth.getReset_2fadmin(payload)
            .then((res) => {
              if (res.status === 200) {
                setTimeout(() => {
                  this.setLoading(false);
                  showToast("success", res.data.message);
                }, 1500);
              }
            })
            .catch((error) => {
              let txt = error.message;
              if (error?.response?.data?.message) {
                txt = error.response.data.message;
              }
              console.log(error);
              showToast("error", txt);
              this.setLoading(false);
            });
        } catch (error) {
          showToast("error", error.message);
          this.setLoading(false);
        }
      } else {
        showToast("info", "Cancelled");
        this.setLoading(false);
      }
    });
  };
  // --- Render Method ---
  render() {
    const { history } = this.props;
    const {
      resProfileAdmin,
      resAllDataMerchang,
      resDataRole,
      nameMerchang,
      merchantId,
    } = this.context;
    const {
      activeTabKey1,
      show,
      isData,
      showModelAdd,
      isLoad,
      tableParams,
      dataTable,
      dropdownPlacement,
      switchLoadindId,
    } = this.state;
    const { handleShowDetail, handleDelete, handleResetTwoFactor } = this;

    const tabList = [
      {
        key: "tab1",
        tab: t("User list"),
      },
    ];
    const userPermissions = Array.isArray(resProfileAdmin?.permissions)
      ? resProfileAdmin.permissions
      : [];

    // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
    const accessible_add = hasPermission(userPermissions, "add_user");

    const columnProps = {
      tableParams,
      nameMerchang,
      dropdownPlacement,
      handleShowDetail,
      handleDelete,
      resProfileAdmin,
      history,
      handleResetTwoFactor,
      switchLoadindId,
    };
    let columns = ColumnsUser(
      columnProps.tableParams,
      columnProps.nameMerchang,
      columnProps.dropdownPlacement,
      columnProps.handleShowDetail,
      columnProps.handleDelete,
      columnProps.resProfileAdmin,
      columnProps.history,
      columnProps.handleResetTwoFactor,
      columnProps.switchLoadindId,
    );

    const accessible = isType.includes(resProfileAdmin?.admin_type);

    let isDataTable = dataTable.filter(
      (item) => !isType.includes(item.admin_type),
    );

    const contentList = {
      tab1: (
        <>
          <div className="body table-responsive">
            <Table
              className="col-lg-12"
              columns={columns}
              rowKey={(record) => record.id}
              onChange={this.handleTableChange}
              dataSource={accessible ? dataTable : isDataTable}
              loading={isLoad}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={t("No data")}
                  />
                ),
              }}
              pagination={{
                ...tableParams.pagination,
                showSizeChanger: true,
                locale: {
                  items_per_page: `/ ${t("paged")}`,
                },
              }}
              scroll={{ x: "max-content" }}
            />
          </div>
        </>
      ),
    };
    return (
      <>
        {/* Modals */}
        <DetailAdminModel
          handleClose={this.handleCloseModals}
          isData={isData}
          showToast={showToast}
          resDataRole={resDataRole}
          nameMerchang={nameMerchang}
          resProfileAdmin={resProfileAdmin}
          show={show}
          t={t}
        />
        <AddAdmin
          resAllDataMerchang={resAllDataMerchang}
          handleClose={this.handleCloseModals}
          show={showModelAdd}
          fetchData={this.fetchData}
          resProfileAdmin={resProfileAdmin}
          nameMerchang={nameMerchang}
          merchantId={merchantId}
          resDataRole={resDataRole}
          t={t}
        />

        {/* Page Content */}
        <div style={{ flex: 1 }}>
          <div>
            <div className="container-fluid">
              <PageHeader
                HeaderText={t("User Management")}
                Breadcrumb={[
                  {
                    name: removeSlashesFromPath(window.location.pathname),
                    navigate: window.location.pathname,
                  },
                ]}
              />
            <br className="sm-hiden" />
            <Card
                title={
                  <>
                    {accessible_add && <Button
                      icon={<UserAddOutlined />}
                      onClick={() => accessible_add ? this.handleShowModelAdd() : alert(t("You don't have permission to add user."))}
                    >
                      {t("add")}
                    </Button>}

                  </>
                }
                extra={
                  <Search
                    placeholder={t("Search by Username")}
                    className=""
                    onSearch={this.onSearch}
                    enterButton
                  />
                }
                tabList={tabList}
                activeTabKey={activeTabKey1}
                onTabChange={this.onTab1Change}
              >
                {contentList[activeTabKey1]}
              </Card>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
});
export default connect(mapStateToProps, null)(withTranslation()(Index));
